<template>
    <el-dialog :visible.sync="dialogVisible" width="404px" custom-class="tooltips-dialog" @close="handleClose"
    	:show-close="false" center :close-on-click-modal="false" destroy-on-close  append-to-body>
		<div class="tooltips">
			<div class="title vcenter">温馨提示</div>
			<div class="content text-justify">根据环太湖动产登记备案综合服务平台相关要求，您需要进一步完善个人基本信息，平台认证通过后，可以正常进行作品备案登记。</div>
			<div class="btnbox between">
				<div class="btn vcenter cur curadm" @click="close">稍后完善</div>
				<div class="btn2 vcenter cur curadm" @click="topersonal">立即完善</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import util from "@/common/util.js";
export default {
    name: 'tooltips',
    props: {
        // 外部参数示例
        // data: {
        //     type: Array,
        //     default: () => []
        // },
    },
    data() {
        return {
            // 内部参数
			dialogVisible:false,
        }
    },
    methods: {
		handleClose(){
			
		},
		close(){
			this.dialogVisible = false
		},
		topersonal(){
			this.dialogVisible = false
			this.$emit("topersonal")
		},
    },
    mounted() {

    }

}
</script>

<style lang="scss">
	@import 'tooltips.scss';
</style>